import React, { useState, useContext } from 'react';
import { Button, Form } from 'react-bootstrap';
import './Reminderactions.css';
import Navbar from '../../../Shared/Navbar/Navbar';
import { ThemeContext } from '../../../Shared/Themes/ThemeContext';
import { baseURL } from '../../../Apiservices/Api';

const Reminderactions = ({ leadid: propLeadId, travelOpportunityId, userId, onActionSuccess }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [comments, setComments] = useState([]);
  const { themeColor } = useContext(ThemeContext);

  const showNavbar = !propLeadId;
  const resolvedUserId = userId || localStorage.getItem("userId");

  const handleAddAction = async () => {
    if (!newComment.trim()) return;

    if (!travelOpportunityId) {
      setError("Travel Opportunity ID is missing.");
      return;
    }

    if (!resolvedUserId) {
      setError("User ID is missing.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const requestBody = {
        userId: parseInt(resolvedUserId),  
        action: newComment.trim(),
        notes: newComment.trim(),
      };

      const response = await fetch(
        `${baseURL}/api/travelopportunity-actions/${travelOpportunityId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to save action.");
      }

      setComments((prev) => [
        {
          name: "You",
          text: newComment.trim(),
          timestamp: new Date().toISOString(),
        },
        ...prev,
      ]);

      setNewComment("");
      setError("");
      
      if (onActionSuccess) {
        onActionSuccess();
      }

    } catch (err) {
      console.error("API Error:", err);
      setError(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ra-salesViewLeadsContainer" style={propLeadId ? { padding: 0 } : {}}>
      {showNavbar && <Navbar onToggleSidebar={setCollapsed} />}
      <div
        className={`ra-salesViewLeads ${collapsed ? "ra-collapsed" : ""}`}
        style={propLeadId ? { margin: 0, padding: "20px" } : {}}
      >
        <div className="ra-comment-form-container-reminder">
          <div className="ra-opp-modal-footer">
            <Form.Group>
              <Form.Label>Add a New Reminder</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Write your reminder here..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                autoFocus
              />

              {error && (
                <p style={{ color: "red", fontSize: "13px", marginTop: "6px" }}>
                  {error}
                </p>
              )}

              <Button
                className="ra-mt-2 ra-opp-comment-btn-primary"
                onClick={handleAddAction}
                disabled={!newComment.trim() || loading}
              >
                {loading ? "Saving..." : "Add Action"}
              </Button>
            </Form.Group>
          </div>

          {comments.length > 0 && (
            <div className="ra-comments-container">
              {comments.map((comment, index) => (
                <div key={index} className="ra-comment">
                  <p className="ra-text-muted">
                    {new Date(comment.timestamp).toLocaleString("en-IN", {
                      timeZone: "Asia/Kolkata",
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </p>
                  <p>
                    <strong>{comment.name}</strong>:{" "}
                    <span style={{ whiteSpace: "pre-line" }}>{comment.text}</span>
                  </p>
                </div>
              ))}
            </div>
          )}

          {showNavbar && (
            <div className="ra-mt-3">
              <Button
                className="ra-comment-close-btn ra-comment-btn"
                onClick={() => window.history.back()}
              >
                Back
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Reminderactions;